import React from 'react'

const getLoading = () => (
	<div className="d-flex align-items-center justify-content-center p-5">
		<i className="fa-solid fa-spinner fa-spin fa-2x"></i>
	</div>
)

export default getLoading;